<app-loader></app-loader>
<div class="company-heading close-class">
<h4>Select Company: <span>Choose one to dive into the dashboard</span> </h4>
<img src="../../../../../assets/images/model-close.svg" (click)="cancelDialog()" alt="Close"/>
</div>
<div class="top-bar owner-list">
    <div class="custom-search">
        <span class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <input type="text" [(ngModel)]="search" pInputText placeholder="Search by Company Name or City or State"
                (ngModelChange)="handleSearchChange()" />
        </span>
    </div>
    <div class="update-time">
        <p>
            Last updated at {{currentDate | date: 'MMM dd, YYYY - HH:mm'}}
        </p>
        <h5>Sort by</h5>
        <div class="custom-select2">
            <div class="filter-parking">
                <p-dropdown [(ngModel)]="selectedSortValue" [options]="items" (onChange)="getCompanyList()"
                    placeholder="Alphabetical - Asc">
                    <ng-template let-item pTemplate="item">
                        <div class="dropdown-item">
                            {{item.label}}
                            <svg *ngIf="item.value === selectedSortValue" width="18" height="14" viewBox="0 0 18 14"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5.99991 11.1698L1.82991 6.99984L0.409912 8.40984L5.99991 13.9998L17.9999 1.99984L16.5899 0.589844L5.99991 11.1698Z"
                                    fill="#1D4ED8" />
                            </svg>
                        </div>
                    </ng-template>
                </p-dropdown>
                <div class="my-icon" aria-label="My icon" [inlineSVG]="'assets/images/fill-dropdown.svg'"></div>
            </div>
        </div>
    </div>
</div>

<div class="parking-stats">
    <div class="parking-counter">
        <div class="no-recordfound" *ngIf="companyList && companyList.length === 0 && noRecordFound">
            No records found!
        </div>
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-4 xl:col-3 custom-spacing-right custom-margin"
                *ngFor="let data of companyList; let i = index"  (click)="navigate(data.id,data.name); setSelectedCompany(data.id)">
                <div class="parking-card" [ngClass]="{'selected': data.id == selectedCompanyId}">
                    <div class="parking-top">
                        <img [src]="data.companyLogoPath ? data.companyLogoPath : dummy" alt="" />
                        <div class="ptop-heading">
                            <h3>{{data.name}}</h3>
                            <h5>
                                <span *ngIf="data?.city">{{ data?.city }}</span>
                                <span *ngIf="data?.state">, {{ data?.state }}</span>
                                <span *ngIf="data?.pincode"> {{ data?.pincode }}</span>
                                <span *ngIf="data?.country">, {{ data?.country }}</span>
                            </h5>
                        </div>
                    </div>
                    <p-divider></p-divider>
                    <div class="bottom-text">
                        <div class="capcity-outer">
                            <h4>Total Parking Lots</h4>
                            <h2>{{data.totalParkingLots}}</h2>
                        </div>
                        <div class="stats-text">
                            <p>Occupancy <strong>{{data.occupancyRate}}%</strong></p>
                            <p-progressBar [value]="data.occupancyRate"></p-progressBar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>